import type { ReactNode } from 'react';
import { useI18n } from '../../../i18n/useI18n';
import './LiksFormFieldLabel.css';

export type LiksFormFieldLabelProps = {
  htmlFor?: string;
  children: ReactNode;
  required?: boolean;
};

export function LiksFormFieldLabel({
  htmlFor,
  children,
  required = false,
}: LiksFormFieldLabelProps) {
  const { translate } = useI18n();

  return (
    <label className="liks-form-field-label" htmlFor={htmlFor}>
      <span>{children}</span>
      {required && (
        <span className="liks-form-field-label__required">
          {/* Visual marker only; screen readers use the translated label below. */}
          <span aria-hidden="true">*</span>
          <span className="liks-form-field-label__sr-only">
            {translate('common.required')}
          </span>
        </span>
      )}
    </label>
  );
}
